/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Virtual TSS device type. AO §146a artTSE Device type:  * `sd` - SD Card  * `usd` - microSD Card  * `usb` - USB Stick  * `cloud` - Cloud device 
 */
export enum VirtualTssDeviceTypeEnumDTO {
    SD = 'sd',
    USD = 'usd',
    USB = 'usb',
    CLOUD = 'cloud'
}

export class ClsVirtualTssDeviceTypeEnumDTO {
    SD = 'sd';
    USD = 'usd';
    USB = 'usb';
    CLOUD = 'cloud';
}

